import { z } from "zod";
import { EVENT_ATTENDANCE_SOURCE } from "../constants/event.constants";
import { eventOccurrenceIdSchema } from "./eventOccurrence.schemas";
import { eventRegistrationIdSchema } from "./eventRegistration.schemas";

export const eventAttendanceLogIdSchema = z.coerce.number().int().positive();

export const eventAttendanceLogSchema = z
	.object({
		eventAttendanceLogId: eventAttendanceLogIdSchema.optional(),
		tenantId: z.coerce.number().int().positive(),
		eventRegistrationId: eventRegistrationIdSchema,
		eventOccurrenceId: eventOccurrenceIdSchema,
		checkInSource: z.enum(EVENT_ATTENDANCE_SOURCE).default("barcode"),
		checkedInAt: z.coerce.date(),
		checkInDate: z.coerce.date(),
		checkedInBy: z.coerce.number().int().positive().nullable(),
		checkOutAt: z.coerce.date().nullable(),
		createdAt: z.coerce.date().optional(),
		updatedAt: z.coerce.date().optional(),
	})
	.strict();

export const createEventAttendanceLogSchema = eventAttendanceLogSchema
	.omit({
		eventAttendanceLogId: true,
		createdAt: true,
		updatedAt: true,
	})
	.extend({
		tenantId: z.coerce.number().int().positive().optional(),
	});
